import { useDataChange, useDataValue } from 'Simple/Data'
import addMonths from 'date-fns/addMonths'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let selected_slot = useDataValue({
    context: 'selected_slot',
    viewPath: props.viewPath,
  })

  let skip = useDataValue({
    context: 'widget',
    path: 'settings.skipMonthIfNoSlots',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected_slot',
    viewPath: props.viewPath,
  })

  return async function onChange(value) {
    let currentDate = new Date()

    // we only want to skip this month otherwise it will continue moving through months
    // but here may be a case where there are no slots
    if (
      !skip ||
      !value ||
      selected_slot.month.getMonth() !== currentDate.getMonth()
    )
      return

    // check whether we have slots for this month
    let hasCurrentMonthSlots =
      Object.keys(value).filter(date => {
        let [year, month] = date.split('-')

        return (
          `${year}${month}` ===
          `${currentDate.getFullYear()}${String(
            new Date().getMonth() + 1
          ).padStart(2, '0')}`
        )
      }) || []

    if (hasCurrentMonthSlots?.length === 0) {
      change(next => {
        next.month = addMonths(selected_slot.month, 1)
      })
    }
  }
}
